import { tsValidateArray, tsValidateBoolean, tsValidateIsInRange, tsValidateNumber, tsValidateOptionalId, tsValidateString, tsValidateUniqueId, tsValidateValue, tsValidator_arrayOfUniqueIds } from '@nu-art/ts-common';
import { operatorTypes } from './types.js';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
import { DBDef_Action } from '../action/index.js';
import { DBDef_OrderGroup } from '../order-group/index.js';
import { Validator_MetaPathwayAction } from '../../_enum/metapathway-action/index.js';
const Validator_TransitionOrderPointer = {
    dbKey: tsValidateValue([DBDef_Action.dbKey, DBDef_OrderGroup.dbKey]),
    id: tsValidateUniqueId,
    expressionId: tsValidateOptionalId,
};
const Validator_ModifiableProps = {
    pathwayIds: tsValidateArray(tsValidateUniqueId),
    sourceId: tsValidateUniqueId,
    targetId: tsValidateUniqueId,
    dds: tsValidateArray({ diseaseProfileId: tsValidateUniqueId, probability: tsValidateIsInRange([[0, 1]], false) }),
    transitionExpression: tsValidateString(undefined, false),
    resolutionFunction: {
        operator: tsValidateValue([...operatorTypes], false),
        expressions: tsValidateArray({ expressionId: tsValidateUniqueId, expectedValue: tsValidateBoolean(false) }, false)
    },
    priorityIndex: tsValidateNumber(),
    resolutionFunctionId: tsValidateOptionalId,
    testsIds: tsValidateArray(Validator_TransitionOrderPointer, false),
    consultIds: tsValidateArray(Validator_TransitionOrderPointer, false),
    nurseIds: tsValidateArray(Validator_TransitionOrderPointer, false),
    additionalOrdersIds: tsValidateArray(Validator_TransitionOrderPointer, false),
    treatmentsIds: tsValidateArray(Validator_TransitionOrderPointer, false),
    label: tsValidateString(undefined, false),
    alert: tsValidateString(undefined, false),
    metaPathwayActions: tsValidateArray(Validator_MetaPathwayAction, false),
};
const Validator_GeneratedProps = {
    _interflowPathwayIds: tsValidator_arrayOfUniqueIds,
    __orderIds: tsValidator_arrayOfUniqueIds,
    __orderGroupIds: tsValidator_arrayOfUniqueIds,
};
export const DBDef_PathwayTransition = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    generatedProps: ['_interflowPathwayIds', '__orderIds', '__orderGroupIds'],
    versions: ['1.0.8', '1.0.7', '1.0.6', '1.0.5', '1.0.4', '1.0.3', '1.0.2', '1.0.1', '1.0.0'],
    dbKey: 'pathway-transitions',
    entityName: 'PathwayTransition',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'pathway-transition'
    },
    backend: {
        name: 'pathway-transitions'
    },
    dependencies: {
        'pathwayIds': {
            dbKey: 'pathway',
            fieldType: 'string[]'
        },
        'sourceId': {
            dbKey: 'pathway-states',
            fieldType: 'string'
        },
        'targetId': {
            dbKey: 'pathway-states',
            fieldType: 'string'
        },
        '_interflowPathwayIds': {
            dbKey: 'pathway',
            fieldType: 'string[]'
        },
        __orderIds: {
            dbKey: DBDef_Action.dbKey,
            fieldType: 'string[]'
        },
        __orderGroupIds: {
            dbKey: DBDef_OrderGroup.dbKey,
            fieldType: 'string[]',
        }
    }
};
//# sourceMappingURL=db-def.js.map